(ns app.new-workspace.events
  (:require [ajax.core :as ajax]
            [app.dashboard.events :as wevents]
            [app.endpoints :refer [delete-workspace-endpoint
                                   update-workspace-name-endpoint workspaces-endpoint upload-image-endpoint update-workspace-icon-endpoint
                                   update-user-icon-endpoint update-account-display-name-endpoint]]
            [day8.re-frame.http-fx]
            [day8.re-frame.tracing :refer-macros [fn-traced]]
            [day8.re-frame.tracing :refer-macros [fn-traced]]
            [re-frame.core :refer [reg-event-db reg-event-fx] :as re-frame]
            [app.login.events :as login-events]
            [app.events :as events]
            [re-posh.core :as re-posh]))

(reg-event-fx
 ::add-new-workspace
 (fn [_world [_ val]]
   (let [{token-id :user/token} @(re-posh/subscribe [::wevents/user-token-id])]
     {:http-xhrio {:method          :post
                   :uri workspaces-endpoint
                   :headers  {"Authorization" (str "Bearer " token-id)}
                   :timeout         5000
                   :mode :cors
                   :format          (ajax/json-request-format)
                   :response-format (ajax/json-response-format {:keywords? true})
                   :params          {:name val}
                   :on-success      [:create-new-wokspace-success]
                   :on-failure      [:endpoint-request-error :get-workspaces]}})))

(reg-event-db
 :create-new-wokspace-success
 (fn [ds [_ data]]
   (re-posh/dispatch [::login-events/add-token  (:token data)])
   (re-frame/dispatch [::wevents/get-workspaces])
   (re-frame/dispatch [::events/navigate [:dashboard-view :id (:workspace-id data)]])
   (re-frame/dispatch [::wevents/add-selected-workspace
                       {:selected-workspace/id (:workspace-id data)
                        :selected-workspace/name (:workspace-name data)}])))

(reg-event-fx
 ::delete-workspace
 (fn [_world [_ val]]
   (let [{token-id :user/token} @(re-posh/subscribe [::wevents/user-token-id])]
     {:http-xhrio {:method          :delete
                   :uri              (delete-workspace-endpoint val)
                   :headers  {"Authorization"  (str "Bearer " token-id)}
                   :timeout         5000
                  ;;  :params val
                   :mode :cors
                   :format          (ajax/json-request-format)
                   :response-format (ajax/json-response-format {:keywords? true})
                   :on-success      [:delete-workspace-success val]
                   :on-failure      [:endpoint-request-error :get-workspaces]}})))

(reg-event-fx
 ::update-workspace-name
 (fn [_ [_ {:keys [workspace-id name]}]]
   (let [{token-id :user/token} @(re-posh/subscribe [::wevents/user-token-id])]
     {:http-xhrio {:method          :put
                   :uri              (update-workspace-name-endpoint workspace-id)
                   :headers  {"Authorization" (str "Bearer " token-id)}
                   :timeout         5000
                   :params {:name name}
                   :mode :cors
                   :format          (ajax/json-request-format)
                   :response-format (ajax/json-response-format {:keywords? true})
                   :on-success      [:update-workspace-success [workspace-id name]]
                   :on-failure      [:endpoint-request-error :get-workspaces]}})))

(reg-event-fx
 ::update-account-display-name
 (fn [_ [_ {:keys [workspace-id display-name]}]]
   (let [{token-id :user/token} @(re-posh/subscribe [::wevents/user-token-id])]
     {:http-xhrio {:method          :put
                   :uri              (update-account-display-name-endpoint workspace-id)
                   :headers  {"Authorization" (str "Bearer " token-id)}
                   :timeout         5000
                   :params {:display-name display-name}
                   :mode :cors
                   :format          (ajax/json-request-format)
                   :response-format (ajax/json-response-format {:keywords? true})
                   :on-success      [:update-workspace-success [workspace-id display-name]]
                   :on-failure      [:endpoint-request-error :get-workspaces]}})))

(reg-event-fx
 ::upload-image
 (fn [_ [_ {:keys [workspace-id file]}]]
   (let [{token-id :user/token} @(re-posh/subscribe [::wevents/user-token-id])]
     {:http-xhrio {:method          :post
                   :uri              (upload-image-endpoint)
                   :headers  {"Authorization" (str "Bearer " token-id)}
                   :timeout         5000
                   :body file
                   :mode :cors
                   :format          (ajax/json-request-format)
                   :response-format (ajax/json-response-format {:keywords? true})
                   :on-success      [:upload-image-success workspace-id]
                   :on-failure      [:endpoint-request-error :get-workspaces]}})))

(reg-event-fx
 ::upload-account-image
 (fn [_ [_ {:keys [workspace-id file]}]]
   (let [{token-id :user/token} @(re-posh/subscribe [::wevents/user-token-id])]
     {:http-xhrio {:method          :post
                   :uri              (upload-image-endpoint)
                   :headers  {"Authorization" (str "Bearer " token-id)}
                   :timeout         5000
                   :body file
                   :mode :cors
                   :format          (ajax/json-request-format)
                   :response-format (ajax/json-response-format {:keywords? true})
                   :on-success      [:upload-account-image-success workspace-id]
                   :on-failure      [:endpoint-request-error :get-workspaces]}})))

(reg-event-fx
 ::update-workspace-icon
 (fn [_ [_ {:keys [workspace-id url]}]]
   (let [{token-id :user/token} @(re-posh/subscribe [::wevents/user-token-id])]
     {:http-xhrio {:method          :put
                   :uri              (update-workspace-icon-endpoint workspace-id)
                   :headers  {"Authorization" (str "Bearer " token-id)}
                   :timeout         5000
                   :params {:url url}
                   :mode :cors
                   :format          (ajax/json-request-format)
                   :response-format (ajax/json-response-format {:keywords? true})
                   :on-success      [:update-workspace-icon-success]
                   :on-failure      [:endpoint-request-error :get-workspaces]}})))

(reg-event-fx
 ::update-user-icon
 (fn [_ [_ {:keys [workspace-id url]}]]
   (let [{token-id :user/token} @(re-posh/subscribe [::wevents/user-token-id])]
     {:http-xhrio {:method          :put
                   :uri              (update-user-icon-endpoint workspace-id)
                   :headers  {"Authorization" (str "Bearer " token-id)}
                   :timeout         5000
                   :params {:url url}
                   :mode :cors
                   :format          (ajax/json-request-format)
                   :response-format (ajax/json-response-format {:keywords? true})
                   :on-success      [:update-workspace-icon-success] ;;change "on-success function"
                   :on-failure      [:endpoint-request-error :get-workspaces]}})))

(reg-event-db
 :upload-image-success
 (fn [_ [_ workspace-id result]]
   (re-posh/dispatch [::update-workspace-icon {:workspace-id workspace-id :url (:url (:content result))}])))

(reg-event-db
 :upload-account-image-success
 (fn [_ [_ workspace-id result]]
   (re-posh/dispatch [::update-user-icon {:workspace-id workspace-id :url (:url (:content result))}])))

(reg-event-db
 :update-workspace-success
 (fn [_ [_ [workspace-id name]]]
   (re-posh/dispatch [::wevents/add-selected-workspace {:selected-workspace/id workspace-id :selected-workspace/name name}])
   (re-frame/dispatch [::wevents/get-workspaces])))

(reg-event-db
 :update-workspace-icon-success
 (fn [_ [_ [_]]]
   (re-frame/dispatch [::wevents/get-workspaces])))

(re-posh/reg-event-ds
 :delete-workspace-success
 (fn-traced [_ [_ data]]
            (re-frame/dispatch [::wevents/get-workspaces])
            [[:db/add 1 :selected-workspace/id ""]]))

(re-posh/reg-event-ds
 ::change-new-workspace
 (fn-traced [_ [_ id val]]
            [[:db/add id :new-workspace/value val]]))